/**
 * @author David Oravec<xorave06@stud.fit.vutbr.cz>
 */
import React, {useContext, useEffect, useState} from 'react';
import {addHeaderToRequests, getFrom, postTo} from "./api";
import {CircularProgress} from "@mui/material";

const authContext = React.createContext(
    {
        id: 0,
        email: "",
        createdAt: new Date(),
        role: 0,
        name: "",
        token: ""
    }
);

function ProvideAuth({ children }) {
    const [loading, setLoading] = useState(true)
    const auth = useProvideAuth();
    useEffect(()=>{
        getFrom('/users/self')
            .then((res) => {
                auth.setAuth(res.data);
                setLoading(false)
            }).catch((e)=>{
                setLoading(false)
            })
    },[])
    if(loading)
        return <CircularProgress/>
    return (
        <authContext.Provider value={auth}>
            {children}
        </authContext.Provider>
    );
}

function useAuth() {
    return useContext(authContext);
}

function useProvideAuth() {
    const [user, setUser] = useState({
        id: 0,
        email: "",
        createdAt: new Date(),
        role: 0,
        name: "",
        token: ""
    });

    const signin = (data, cbsuc, cberr)=> {

        postTo('/login', data)
            .then((res)=>{
                if(res.data.token) addHeaderToRequests('Authorization', `Bearer ${res.data.token}`)
                getFrom('/users/self' )
                    .then((user)=>{
                        setUser(Object.assign(user.data, res.data));
                        cbsuc();
                    })
                    .catch((e)=>{
                        console.error("ERROR");
                        signout(cberr);
                    })
            })
            .catch((e)=>{
                console.error("ERROR");
                signout(cberr);
            })
    };

    const signout = cb => {
        setUser(undefined);
        cb("SignOut-Param");
        addHeaderToRequests('Authorization', '')
        postTo('/logout', {})
            .then((res)=>{
                cb('Logged out')
            })
            .catch((e)=>{
                console.error(e)
                cb('Error')
            })
        // return fakeAuth.signout(() => {
        //     setUser(null);
        //     cb();
        // });
    };

    const setAuth = (userData) => {
        setUser(userData);
    }

    return {
        user,
        signin,
        signout,
        setAuth
    };
}

export {authContext, useAuth, ProvideAuth};
